import { useMutation } from '@tanstack/react-query'
import { useApiClientDocument } from '~/@api/client/useApiClientDocument'
import { downloadPDF } from '~/@lib/utils/files.utils'

// On-the-fly generované PDF (daňový výpis, oznámenie o zmene rámcovky) — presunuté
// z Meteor `user/account/portfolio/documents/*` na Nest `GET /document/tax-statement`
// a `GET /document/fee-notice` (`/document` doc, apiClientDocument). PDF príde v base64 v `data`.
function useDocumentDownloads() {
  const client = useApiClientDocument()

  const downloadTaxStatementMutation = useMutation({
    mutationFn: async () => {
      const { data } =
        await client.document.pdfGeneratorsControllerGetTaxStatement({
          secure: true,
        })
      downloadPDF(data.data, 'danovy-vypis.pdf')
      return data
    },
  })

  const downloadFeeNoticeMutation = useMutation({
    mutationFn: async () => {
      const { data } =
        await client.document.pdfGeneratorsControllerGetFeeNotice({
          secure: true,
        })
      downloadPDF(data.data, 'oznamenie-o-zmene-ramcovej-zmluvy.pdf')
      return data
    },
  })

  return {
    isDownloadingTaxStatement: downloadTaxStatementMutation.isPending,
    downloadAgreementTaxStatementDocument: downloadTaxStatementMutation.mutate,

    isDownloadingFeeNotice: downloadFeeNoticeMutation.isPending,
    downloadFeeNoticeDocument: downloadFeeNoticeMutation.mutate,
  }
}

export { useDocumentDownloads }
